import { createBlock, mergeBlock, t } from "@easy-email-pro-core/utils";

import { BasicType, ElementCategory } from "@easy-email-pro-core/constants";
import {
  TextNode,
  LineBreakElement,
  ElementDefinition,
} from "@easy-email-pro-core/typings";
import React from "react";
import { BasicBlock, ContentLeaf } from "@easy-email-pro-core/components";

const defaultData: ElementDefinition<LineBreakElement>["defaultData"] = {
  attributes: {},
  data: {},
};

export const LineBreak = createBlock<LineBreakElement>({
  get name() {
    return t("Line break");
  },
  defaultData,
  type: BasicType.LINE_BREAK,
  create: (payload) => {
    const defaultData: LineBreakElement = {
      type: BasicType.LINE_BREAK,
      data: {},
      attributes: {},
      children: [],
    };
    return mergeBlock(defaultData, payload);
  },
  inlineElement: true,
  category: ElementCategory.INLINE_TEXT,
  render(params) {
    if (params.mode === "production") {
      const child = params.node.children[0] as TextNode;
      return (
        <ContentLeaf
          node={{
            ...child,
            text: "<br />",
          }}
        />
      );
    }
    return (
      <BasicBlock
        tag={"span"}
        params={{
          ...params,
          node: {
            ...params.node,
            attributes: {
              "element-type": BasicType.LINE_BREAK,
              "element-category": ElementCategory.INLINE_TEXT,
            } as any,
          },
        }}
      />
    );
  },
});
